var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTz = function SvgTz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M102.9 0h496v496H103z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tz_svg__a)",
    transform: "translate(-106.2)scale(1.0321)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M0 0h744.1v496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M0 0h744.1L0 496z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M0 496h165.4L744 103.4V0H578.7L0 392.7v103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 378 567 0h56L0 415.3v-37.2zm121.1 118 623-415.3V118L177 496z"
  })))));
};
export default SvgTz;